var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.35 2.70001H18.9C19.3508 2.70001 19.7832 2.87911 20.1021 3.19792C20.4209 3.51674 20.6 3.94914 20.6 4.40001V21.4C20.6 21.8509 20.4209 22.2833 20.1021 22.6021C19.7832 22.9209 19.3508 23.1 18.9 23.1H5.29998C4.84911 23.1 4.41671 22.9209 4.09789 22.6021C3.77908 22.2833 3.59998 21.8509 3.59998 21.4V4.40001C3.59998 3.94914 3.77908 3.51674 4.09789 3.19792C4.41671 2.87911 4.84911 2.70001 5.29998 2.70001H7.84998M16.35 2.70001C16.35 1.76112 15.5888 1 14.65 1H9.54995C8.61107 1 7.84998 1.76112 7.84998 2.70001M16.35 2.70001L16.3499 3.55C16.3499 4.48888 15.5888 5.25 14.65 5.25H9.54995C8.61107 5.25 7.84995 4.48888 7.84995 3.55L7.84998 2.70001M7.84995 9.5H16.3499M7.84995 13.75H16.3499M7.84995 18H16.3499",
    stroke: "#AA1A5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/taskIcon.4d3abe8fa9c980d9ccf1e47374b044b3.svg";
export { ForwardRef as ReactComponent };